import { Text } from 'style-utils/components/Text';
import {
  withWidth,
  WithWidthProps,
} from 'style-utils/withStyledProps/withWidthProps';
import {
  withSpacing,
  WithSpacingProps,
} from 'style-utils/withStyledProps/withSpacingProps';
import styled, { css } from 'styled-components';
import {
  withHeight,
  WithHeightProps,
} from 'style-utils/withStyledProps/withHeightProps';
import variant from 'style-utils/core/variant/variant';

type ButtonVariant = 'primary' | 'secondary' | 'thertiary' | 'outlined';

export type ButtonBaseProps = WithSpacingProps &
  WithWidthProps &
  WithHeightProps & {
    borderRadius?: string;
    variant?: ButtonVariant;
  };

const withButtonVariant = variant({
  variants: {
    primary: {
      background: 'primaryButtonBg',
      [`${Text}`]: {
        color: 'primaryButtonColor',
      },
    },
    secondary: {
      background: 'secondaryButtonBg',
    },
    thertiary: {
      background: 'thertiaryButtonBg',
    },
    outlined: {
      background: 'transparent',
      border: '2px solid',
      color: 'outlinedButtonColor',
      [`${Text}`]: {
        color: 'outlinedButtonColor',
      },
    },
  },
});

export const withButtonStyles = css<ButtonBaseProps>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: ${({ borderRadius = '.8rem' }) => borderRadius};

  ${withHeight};
  ${withWidth};
  ${withSpacing};

  border: none;
  outline: none;

  &[disabled] {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.5;
  }

  ${withButtonVariant}
`;

export const ButtonBase = styled.button.attrs((props: ButtonBaseProps) => ({
  variant: props.variant || 'primary',
}))<ButtonBaseProps>`
  ${withButtonStyles}
`;

ButtonBase.displayName = 'ButtonBase';
